import { ISinglePlacedOrder } from '../../services/types/orders.type';
import { compareDates } from '../arrayUtils';

export const sortOrderPickupTimeAsc = (firstOrder: ISinglePlacedOrder, secondOrder: ISinglePlacedOrder): number =>
  compareDates(new Date(firstOrder.pickupTime), new Date(secondOrder.pickupTime));

export const sortOrderPickupTimeDesc = (firstOrder: ISinglePlacedOrder, secondOrder: ISinglePlacedOrder): number =>
  compareDates(new Date(secondOrder.pickupTime), new Date(firstOrder.pickupTime));
